'use strict';exports.__esModule = true;exports.resetForm = exports.clearFieldsConfig = exports.getFieldsConfig = exports.getPropertyTypesValues = exports.sendPropertyData = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);

var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var PUBLISH_REQUEST_TIMEOUT = _constants.publishConfig.requestTimeout;
var TIMEOUT_ERROR_CODE = 'ECONNABORTED';

var infoName = function infoName(name) {return '/' + name;};

var PUBLISH_PROPERTY = infoName('PUBLISH_PROPERTY');
var PUBLISH_PROPERTY_SUCCESS = infoName('PUBLISH_PROPERTY_SUCCESS');
var PUBLISH_PROPERTY_FAIL = infoName('PUBLISH_PROPERTY_FAIL');
var GET_PROPERTY_TYPES_VALUES = infoName('GET_PROPERTY_TYPES_VALUES');
var RECEIVE_PROPERTY_TYPES_SUCCESS = infoName('RECEIVE_PROPERTY_TYPES_SUCCESS');
var RECEIVE_PROPERTY_TYPES_FAIL = infoName('RECEIVE_PROPERTY_TYPES_FAIL');
var GET_FIELDS_CONFIG = infoName('GET_FIELDS_CONFIG');
var RECEIVE_FIELDS_CONFIG_SUCCESS = infoName('RECEIVE_FIELDS_CONFIG_SUCCESS');
var RECEIVE_FIELDS_CONFIG_FAIL = infoName('RECEIVE_FIELDS_CONFIG_FAIL');
var CLEAR_FIELDS_CONFIG = infoName('CLEAR_FIELDS_CONFIG');

var sendPropertyData = (0, _reduxAct.createAction)(PUBLISH_PROPERTY);
var publishPropertySuccess = (0, _reduxAct.createAction)(PUBLISH_PROPERTY_SUCCESS);
var publishPropertyFail = (0, _reduxAct.createAction)(PUBLISH_PROPERTY_FAIL);
var getPropertyTypesValues = (0, _reduxAct.createAction)(GET_PROPERTY_TYPES_VALUES);
var receivePropertyTypesSuccess = (0, _reduxAct.createAction)(RECEIVE_PROPERTY_TYPES_SUCCESS);
var receivePropertyTypesFail = (0, _reduxAct.createAction)(RECEIVE_PROPERTY_TYPES_FAIL);
var getFieldsConfig = (0, _reduxAct.createAction)(GET_FIELDS_CONFIG);
var receiveFieldsConfigSuccess = (0, _reduxAct.createAction)(RECEIVE_FIELDS_CONFIG_SUCCESS);
var receiveFieldsConfigFail = (0, _reduxAct.createAction)(RECEIVE_FIELDS_CONFIG_FAIL);
var clearFieldsConfig = (0, _reduxAct.createAction)(CLEAR_FIELDS_CONFIG);
var resetForm = (0, _reduxAct.createAction)('/RESET_FORM');

var initialState = {
  publishing: false,
  published: false,
  propertyTypes: null,
  config: null,
  fetchingData: false };


var fetchPublishProperty = function fetchPublishProperty(_ref) {var propertyData = _ref.propertyData,access_token = _ref.access_token;return (
    _axios2.default.post('/properties', propertyData, { headers: { access_token: access_token }, timeout: PUBLISH_REQUEST_TIMEOUT }).
    then(publishPropertySuccess).
    catch(publishPropertyFail));};

var fetchPropertyTypes = function fetchPropertyTypes(_ref2) {var section = _ref2.section,optionType = _ref2.optionType;return (
    _axios2.default.get('/property-types/' + section + '/' + optionType).
    then(receivePropertyTypesSuccess, receivePropertyTypesFail));};

var fetchFieldsConfig = function fetchFieldsConfig(params) {return (
    _axios2.default.get('/publish-config', { params: params }).
    then(receiveFieldsConfigSuccess, receiveFieldsConfigFail));};

var publishPropertyHandler = function publishPropertyHandler(state, value) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    published: false,
    error: null }),
  promise(fetchPublishProperty, value));};

var publishPropertyHandlerSuccess = function publishPropertyHandlerSuccess(state, action) {return Object.assign({},
  state, {
    published: true,
    data: action,
    error: null });};


var publishPropertyHandlerFail = function publishPropertyHandlerFail(state, action) {
  var error = action.code === TIMEOUT_ERROR_CODE ?
  { message: 'TIMEOUT', code: action.code } :
  action.response.data;

  return Object.assign({},
  state, {
    published: false,
    data: null,
    error: error });

};

var receivingPropertyTypesHandler = function receivingPropertyTypesHandler(state, params) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    config: null,
    fetchingData: true }),
  promise(fetchPropertyTypes, params));};

var receivePropertyTypesHandlerSuccess = function receivePropertyTypesHandlerSuccess(state, _ref3) {var data = _ref3.data;return Object.assign({},
  state, {
    propertyTypes: data,
    fetchingData: false,
    error: null });};



var receivePropertyTypesHandlerFail = function receivePropertyTypesHandlerFail(state, error) {
  (0, _formatApiError2.default)(error, 'Error while receiving property types for publish');
  return Object.assign({},
  state, {
    propertyTypes: null,
    fetchingData: false,
    error: error });

};

var receivingFieldsConfigHandler = function receivingFieldsConfigHandler(state, params) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    fetchingData: true }),
  promise(fetchFieldsConfig, params));};

var receiveFieldsConfigHandlerSuccess = function receiveFieldsConfigHandlerSuccess(state, _ref4) {var data = _ref4.data;return Object.assign({},
  state, {
    config: data,
    fetchingData: false,
    error: null });};


var receiveFieldsConfigHandlerFail = function receiveFieldsConfigHandlerFail(state, error) {
  console.error(error);
  return Object.assign({},
  state, {
    config: null,
    fetchingData: false,
    error: error });

};

var handleClearFieldsConfig = function handleClearFieldsConfig(state) {return Object.assign({},
  state, {
    config: null });};


var handleResetForm = function handleResetForm() {return Object.assign({},
  initialState);};


var publishProperty = (0, _reduxAct.createReducer)(function (on) {
  on(sendPropertyData, publishPropertyHandler);
  on(publishPropertySuccess, publishPropertyHandlerSuccess);
  on(publishPropertyFail, publishPropertyHandlerFail);
  on(getPropertyTypesValues, receivingPropertyTypesHandler);
  on(receivePropertyTypesSuccess, receivePropertyTypesHandlerSuccess);
  on(receivePropertyTypesFail, receivePropertyTypesHandlerFail);
  on(getFieldsConfig, receivingFieldsConfigHandler);
  on(receiveFieldsConfigSuccess, receiveFieldsConfigHandlerSuccess);
  on(receiveFieldsConfigFail, receiveFieldsConfigHandlerFail);
  on(clearFieldsConfig, handleClearFieldsConfig);
  on(resetForm, handleResetForm);
}, initialState);exports.


sendPropertyData = sendPropertyData;exports.
getPropertyTypesValues = getPropertyTypesValues;exports.
getFieldsConfig = getFieldsConfig;exports.
clearFieldsConfig = clearFieldsConfig;exports.
resetForm = resetForm;exports.default =


publishProperty;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/publishProperty.js
// module id = 593
// module chunks = 0